import { object, number, array } from '@gogame/schemas';

import {
  FILTER_STATUSES,
  FILTER_PARTNER_COMPANIES,
  FILTER_BUSINESS_PARTNERS,
  FILTER_CAMPAIGN_NETWORKS,
  FILTER_CAMPAIGN_APPLICATIONS,
  FILTER_CAMPAIGN_PLATFORMS,
  FILTER_CAMPAIGN_CLUSTERS,
  FILTER_TRAFFIC_TYPES,
  FILTER_EXPENSE_TYPES,
  FILTER_CHANNEL_TYPE,
  FILTER_OWNERS,
  FILTER_CREATED_BY,
  FILTER_CHANNELS,
  STATUS_ACTIVE,
  STATUS_IN_TEST,
} from 'scenes/Affiliates/constants';

export const EMPTY_FILTERS = {
  [FILTER_STATUSES]: [STATUS_ACTIVE, STATUS_IN_TEST],
};

export const filtersSchema = object({
  [FILTER_STATUSES]: array(number()),
  [FILTER_PARTNER_COMPANIES]: array(number()),
  [FILTER_BUSINESS_PARTNERS]: array(number()),
  [FILTER_CAMPAIGN_NETWORKS]: array(number()),
  [FILTER_CAMPAIGN_APPLICATIONS]: array(number()),
  [FILTER_CAMPAIGN_PLATFORMS]: array(number()),
  [FILTER_CAMPAIGN_CLUSTERS]: array(number()),
  [FILTER_TRAFFIC_TYPES]: array(number()),
  [FILTER_EXPENSE_TYPES]: array(number()),
  [FILTER_OWNERS]: array(number()),
  [FILTER_CREATED_BY]: array(number()),
  [FILTER_CHANNELS]: array(number()),
  [FILTER_CHANNEL_TYPE]: number(),
}).default(EMPTY_FILTERS);
